module.exports = __webpack_public_path__ + "img/Grupo 1120.08bef7ad.png";